import { render, staticRenderFns } from "./Fitnessplan.vue?vue&type=template&id=5c8cecdb&"
import script from "./Fitnessplan.vue?vue&type=script&lang=js&"
export * from "./Fitnessplan.vue?vue&type=script&lang=js&"
import style0 from "./Fitnessplan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports